import { paginationPageSize } from "@/Constant";
import { setComponentState1 } from "@/features/retain_state/retainStateSlice";
import { formatAmountUnitDecimalPlace } from "@/utility/common";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const useColumnBallotDefs = () => {
  const { t } = useTranslation();
  const caseDataDetails = useSelector((state: any) => state.case);
  const retainState = useSelector(
    (e: any) => e.retainState.creditorVotesTabState
  );
  const dispatch = useDispatch();
  const amountCellRenderer = (field: string) => (params: any) => {
    const { defaultUnit } = caseDataDetails;
    const decimalPlace = field === "claim" ? defaultUnit?.decimalPlace : 2;
    const amount = params.data[field];
    return amount !== null
      ? formatAmountUnitDecimalPlace(amount, decimalPlace) + "%"
      : "-";
  };
  return [
    {
      cellRenderer: (params: any) => (
        <Link
          to={`./voting/edit/` + params?.data?.id}
          onClick={() => {
            if (retainState.ballotVersionId !== params?.data?.id) {
              dispatch(
                setComponentState1({
                  entityName: "creditorVotesTabState",
                  entityState: {
                    ballotVersionId: "",
                    PageNumber: 1,
                    SearchText: "",
                    SortOrder: "asc",
                    SortColumn: "VoterName",
                    PageSize: paginationPageSize,
                    sortedColumnTypes: { voterNameType: { sort: "asc" } },
                  },
                })
              );
            }
          }}
        >
          <span className="text-bold-underline">
            {" "}
            {params?.data?.ballotName}
          </span>
        </Link>
      ),
      comparator: () => 0,
      field: "ballotName",
      type: "ballotNameType",
      headerName: t("pages.voting.tableColumnsDetails.column1"),
      flex: 1,
      sortable: true,
      unSortIcon: true,
      wordWrap: true,
      autoHeight: true,
      minWidth: 180,
      cellClass: "overFlowWrapAnywhere",
    },
    {
      comparator: () => 0,
      field: "className",
      type: "classNameType",
      headerName: t("pages.voting.tableColumnsDetails.column2"),
      flex: 1,
      sortable: true,
      minWidth: 180,

      unSortIcon: true,
    },
    {
      comparator: () => 0,
      field: "meetingName",
      type: "meetingNameType",
      headerName: t("pages.voting.tableColumnsDetails.column3"),
      flex: 1,
      sortable: true,
      minWidth: 180,

      unSortIcon: true,
    },
    {
      comparator: () => 0,
      field: "status",
      type: "statusType",
      headerName: t("pages.voting.tableColumnsDetails.column4"),
      flex: 1,
      cellRenderer: function (params: any) {
        return params.data.status === true ? "Open" : "Locked";
      },
      sortable: true,
      minWidth: 180,

      unSortIcon: true,
    },
    {
      comparator: () => 0,
      field: "yesVotesCountPercentage",
      type: "successConditionCreditorCountType",
      headerName: t("pages.voting.tableColumnsDetails.column5"),
      flex: 1,
      sortable: true,
      minWidth: 180,

      unSortIcon: true,
      // headerClass: 'stepHeaderClass',
      // cellClass:"align-right",
      cellRenderer: amountCellRenderer("yesVotesCountPercentage"),
    },
    {
      comparator: () => 0,
      field: "yesVotesAmountPercentage",
      type: "successConditionClaimValueType",
      headerName: t("pages.voting.tableColumnsDetails.column6"),
      flex: 1,
      sortable: true,
      minWidth: 180,

      unSortIcon: true,
      // headerClass: 'stepHeaderClass',
      // cellClass:"align-right",
      cellRenderer: amountCellRenderer("yesVotesAmountPercentage"),
    },
    {
      cellRenderer: function (params: any) {
        return params.data.isProxyRequired === true ? "Yes" : "No";
      },

      comparator: () => 0,
      field: "isProxyRequired",
      type: "isProxyRequiredType",
      headerName: t("pages.voting.tableColumnsDetails.column7"),
      flex: 1.2,
      sortable: true,
      minWidth: 180,

      unSortIcon: true,
    },
    // {
    //   cellRenderer: "actionCellRenderers",

    //   comparator: () => 0,
    //   field: "action",
    //   headerName: "",
    //   flex: 1,
    //   sortable: false,
    // },
  ];
};
